import styles from "./OurValues.module.css";
import SectionHeader from "./SectionHeader";

const values = [
  {
    title: "Speed",
    description:
      "We get things done and have a bias towards action. We run a marathon and not a sprint. Though it's still a race.",
  },
  {
    title: "Simplicity",
    description:
      "We keep things simple and prefer pragmatic solutions over complicated abstractions. We cut away cargo cult.",
  },
  {
    title: "Transparency",
    description:
      "We communicate early and often. We don’t have secrets but respect privacy and are honest if things went bad.",
  },
  {
    title: "Trust",
    description:
      "All of us own a piece of Raycast and we trust each other to do what they think is best for the company.",
  },
  {
    title: "Quality",
    description: "We don’t settle on mediocrity and choose quality over quantity. Even if the solutions are harder.",
  },
  {
    title: "Inclusivity",
    description:
      "We come from different backgrounds and reflect our diverse community. We treat each other as we want to be treated.",
  },
];

const OurValues = () => {
  return (
    <div className={styles.ourValues}>
      <SectionHeader title="Our values" anchor="our-values">
        Applying our values is what helps us thrive, enjoy what we do, and ship our best work.
      </SectionHeader>
      <div className={styles.valuesWrapper}>
        {values.map((value) => (
          <div className={styles.value} key={value.title}>
            <h4>{value.title}</h4>
            <p>{value.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurValues;
